import {
  GetStaffLoginStatusDocument,
  GetStaffLoginStatusQuery,
  UpdateBizStaffDocument,
  UpdateBizStaffMutation,
  UpdateStaffStateDocument,
  UpdateStaffStateMutation,
} from "@/framework/network/gql/generated/graphql";
import { GraphqlApi, IGraphqlApi } from "@/framework/network/gql/GraphqlApi";
import GraphqlApiError from "@/framework/network/gql/GraphqlApiError";
import { err, ok, Result } from "neverthrow";
import { GeneralResponse, GeneralResponseSchema } from "@/framework/objects/GeneralResponse";
import {
  StaffLoginStatus,
  StaffLoginStatusSchema,
  UpdateStaffStateResponse,
  UpdateStaffStateResponseSchema,
} from "@/modules/staff/objects/Staff";

export class LoginStatusApiService {
  private _graphql: IGraphqlApi;

  public constructor(graphql: IGraphqlApi = new GraphqlApi()) {
    this._graphql = graphql;
  }

  async updateLoginStatus(
    groupIds: number[],
    state: string
  ): Promise<Result<UpdateStaffStateResponse[], GraphqlApiError>> {
    const v = { groupIds, state };
    const result = await this._graphql.runMutationAndValidate<UpdateStaffStateMutation, UpdateStaffStateResponse[]>(
      UpdateStaffStateDocument,
      UpdateStaffStateResponseSchema,
      v
    );
    if (result.isErr()) {
      return err(result.error);
    } else {
      return ok(result.value);
    }
  }

  async getLoginStatus(): Promise<Result<StaffLoginStatus[], GraphqlApiError>> {
    const res = await this._graphql.runQueryAndValidate<GetStaffLoginStatusQuery, StaffLoginStatus[]>(
      // @ts-ignore conflict between generic typing and exact requirement
      GetStaffLoginStatusDocument,
      StaffLoginStatusSchema,
      {}
    );
    if (res.isErr()) {
      return err(res.error);
    } else {
      return ok(res.value);
    }
  }

  async updateLogin(state: string): Promise<Result<GeneralResponse, GraphqlApiError>> {
    const res = await this._graphql.runMutationAndValidate<UpdateBizStaffMutation, GeneralResponse>(
      // @ts-ignore conflict between generic typing and exact requirement
      UpdateBizStaffDocument,
      GeneralResponseSchema,
      { state: state }
    );
    if (res.isErr()) {
      return err(res.error);
    } else {
      return ok(res.value);
    }
  }
}
